import DetailButtonsContainer from '@components/atoms/container/detailButtonsContainer';
import DetailContext from '@shared/components/utils/context/detailContext';
import Focus from '@shared/types/enums/focus';
import List from '@components/sections/list/list';
import UpgradeButton from '../buttons/upgradeButton';
import { pushFocus, setFocus } from '@shared/store/slices/focus.slice';
import { useAppDispatch } from '@shared/store/hooks';
import { useCallback, useContext } from 'react';

export default function DetailButtons() {
  const dispatch = useAppDispatch();
  const { buttons } = useContext(DetailContext);

  // Actions

  const onMouseEnter = useCallback(() => {
    dispatch(setFocus(Focus.DETAIL_BUTTONS));
  }, []);

  const outOfBounds = useCallback(
    (_focus: Focus | number | string, exit?: string) => {
      if (exit === 'LEFT') {
        dispatch(pushFocus(Focus.MENU));
      }
    },
    []
  );

  return (
    <DetailButtonsContainer onMouseEnter={onMouseEnter} id={'detailButtons'}>
      <List focus={Focus.DETAIL_BUTTONS} outOfBounds={outOfBounds}>
        {buttons?.map((item, index) => {
          return (
            <UpgradeButton
              key={index}
              index={index}
              item={item.title}
              releaseAction={item.action}
            />
          );
        })}
      </List>
    </DetailButtonsContainer>
  );
}
